(function() { module.exports = this["wp"]["viewport"]; }());